module.exports = __webpack_public_path__ + "img/loading1.5b90876a.svg";